import React from "react";

import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { CenteredGreedy } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";

import { ApiModel } from "constants/loading";

import { BusinessUserTabs } from "containers/LivestockSales/BusinessUserTabs";

import { getIsBusinessUser, getSaleById, getSaleLots } from "selectors";

import { SaleRoutes } from "./SaleRoutes";
import SaleTabs from "./SaleTabs";

const InfoText = styled(CenteredGreedy)`
  padding: ${({ theme }) => theme.space[3]}px;
`;

type LivestockSaleParams = {
  saleId: string;
  saleyard: string;
};

export const LivestockSale = React.memo(() => {
  const params = useParams<LivestockSaleParams>();

  const { saleId: saleIdRaw, saleyard } = params;
  const sale = useSelector(getSaleById(Number(saleIdRaw)));
  const saleLots = useSelector(getSaleLots);
  const isBusinessUser = useSelector(getIsBusinessUser);

  if (!sale) {
    return null;
  }

  const {
    livestocksale_id: saleId,
    sale_type: saleType,
    saleyard_id: saleyardId,
  } = sale;

  if (isBusinessUser && !Object.values(saleLots).length) {
    return (
      <WaitForSync requiredData={[ApiModel.SALE_LOTS]}>
        <InfoText>
          <h2>No Sale Lots have been transacted in this sale</h2>
        </InfoText>
      </WaitForSync>
    );
  }

  return (
    <>
      {isBusinessUser && <BusinessUserTabs />}
      <SaleTabs />
      <SaleRoutes
        saleId={saleId}
        saleType={saleType}
        saleyardId={saleyardId}
        saleyardName={saleyard}
      />
    </>
  );
});
